import React from 'react';
import Settings from './Setting';
import EntitySettings from './EntitySettings';
interface ISettingsProps {
  cur_case: any;
  trigger: boolean;
  setTrigger: any;
  setAutoTab: any;
  cur_user: any;
}

const SettingsComponent: React.FC<ISettingsProps> = ({
  cur_case,
  trigger,
  setTrigger,
  setAutoTab,
  cur_user,
}) => {
  return (
    <>
      <div className='setting-frame'>
        <Settings
          cur_case={cur_case}
          trigger={trigger}
          setTrigger={setTrigger}
          setAutoTab={setAutoTab}
          cur_user={cur_user}
        />
        {cur_case.data.docType !== 'Classification' && (
          <EntitySettings cur_case={cur_case} />
        )}
      </div>
    </>
  );
};

export default SettingsComponent;
